<template>
  <div class="page_container">
    <div class="ordering_rule_list">
      <div
        :class="[
          'ordering_rule_item',
          item.key === orderingRuleActive ? 'active' : '',
          item.disabled ? 'disabled' : ''
        ]"
        :style="item.style"
        v-for="item in orderingRuleList"
        :key="item.title"
        @click="handleOrderingRuleItem(item)"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="search_container">
      <div class="search_container_left">
        <a-input
          v-model:value="searchKeywords"
          placeholder="输入教室、老师、课程关键字"
          @keyup.enter="handleSearchKeywords"
        >
          <template #suffix>
            <img
              src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/4f335c6bd8924a9980e301ed818df3c5.png"
              alt="搜索"
              style="cursor: pointer"
              @click="handleSearchKeywords"
            />
          </template>
        </a-input>
        <a-radio-group v-model:value="classStatus" style="margin-left: 32px" @change="handleClassStatusChange">
          <a-radio value="all">全部({{ classroomExt.classroomSumTotal || 0 }})</a-radio>
          <a-radio value="inClass">上课中({{ classroomExt.inUseClassroomTotal || 0 }})</a-radio>
          <a-radio value="powerOff">已关机({{ classroomExt.notInUseClassroomTotal || 0 }})</a-radio>
        </a-radio-group>
      </div>
      <div class="search_container_right" v-if="totalCount > pageSize">
        <a-pagination
          v-model:current="currentPage"
          :pageSize="pageSize"
          :total="totalCount"
          show-less-items
          @change="paginationChange"
        />
      </div>
    </div>
    <div class="body_container">
      <div class="body_container_loading" v-if="classroomCourseListLoading">
        <a-spin />
      </div>
      <div class="body_container_content" v-if="classroomCourseList.length">
        <div
          class="classroom_course_item"
          v-for="(item, index) in classroomCourseList"
          :key="index"
          @click="handleClassroomCourseItem(item)"
        >
          <div class="classroom_course_item_video">
            <template v-if="item.status === 1">
              <div
                class="J_prismPlayer_class"
                :id="`J_prismPlayer_video_teacherUserId${item.teacherUserId}`"
                v-if="item.rtcType === 'artc'"
              ></div>
              <video src="" autoplay muted :id="`video_teacherUserId${item.teacherUserId}`" v-else></video>
              <div class="classroom_course_item_video_bar">
                <microphone-icon v-if="item.speaking" :barHeightForAudio="item.barHeightForAudio || '0%'" />
              </div>
              <div class="video_mask_container" v-if="!item.videoShow">
                <div class="sk-fading-circle">
                  <div class="sk-circle1 sk-circle"></div>
                  <div class="sk-circle2 sk-circle"></div>
                  <div class="sk-circle3 sk-circle"></div>
                  <div class="sk-circle4 sk-circle"></div>
                  <div class="sk-circle5 sk-circle"></div>
                  <div class="sk-circle6 sk-circle"></div>
                  <div class="sk-circle7 sk-circle"></div>
                  <div class="sk-circle8 sk-circle"></div>
                  <div class="sk-circle9 sk-circle"></div>
                  <div class="sk-circle10 sk-circle"></div>
                  <div class="sk-circle11 sk-circle"></div>
                  <div class="sk-circle12 sk-circle"></div>
                </div>
                <p class="video_mask_container_title">正在开启实时预览，请稍候...</p>
              </div>
              <div class="video_mask_container_real_top" v-if="item.zrtcStatus === 0">
                <div class="video_mask_container_real_top_title">
                  <img
                    src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202403/149e6189e3c94665b029197ba527477c.png"
                    alt="开关"
                  />
                  <p>已关机</p>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="power_off_container">
                <div class="power_off_container_title">
                  <img
                    src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202403/bf309c418662488592807b7cc7da25f8.png"
                    alt="开关"
                  />
                  <p>已关机</p>
                </div>
                <div class="power_off_container_sub_title">点击可查看本教室历史回放</div>
              </div>
            </template>
          </div>
          <div class="classroom_course_item_info">
            <p class="info_title">{{ item.classroomName || '- -' }}</p>
            <p class="info_sub_title">
              {{ item.teacherName && item.liveName ? `${item.teacherName} - ${item.liveName}` : '- -' }}
            </p>
          </div>
        </div>
      </div>
      <div class="body_container_empty" v-if="classroomCourseListEmpty">
        <a-empty :image="Empty.PRESENTED_IMAGE_SIMPLE" />
      </div>
    </div>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue'
import { mapGetters, mapMutations } from 'vuex'
import { SOCKET_MSG_TYPE } from '@/consts/socketMsg'
import { VIDEO_LEVEL } from '@/consts/camera'
const classStatusObj = {
  all: -1,
  inClass: 1,
  powerOff: 0
}
const sortByObj = {
  level: 1,
  state: 2
}
export default {
  name: 'OnLineInspectionTour',
  components: {
    'microphone-icon': () => import('@/components/microphoneIcon/index.vue')
  },
  data() {
    return {
      Empty,
      orderingRuleList: [
        {
          title: '按状态排序',
          key: 'state',
          disabled: false,
          style: {}
        },
        {
          title: '按楼层排序',
          key: 'level',
          disabled: false,
          style: {
            borderLeft: 'none'
          }
        }
      ],
      searchKeywords: '',
      classStatus: 'all',
      currentPage: 1,
      pageSize: 9,
      totalCount: 0,
      classroomExt: {},
      classroomCourseList: [],
      classroomCourseListLoading: false,
      classroomCourseListEmpty: false,
      ZRTCClientMap: new Map(),
      classroomCourseListStatusStarting: [],
      socketMsgSmallRoom: {},
      preVideoStreamIdList: [],
      mapAliplayerVideo: new Map(),
      timerIdIntervalGetClassroomCourseList: 0,
      timerIdTimeoutGetClassroomCourseList: 0,
      haveoOnSignalMessageMap: new Map(),
      mapStreamIdVolume: new Map()
    }
  },
  computed: {
    ...mapGetters('switchingSchool', ['schoolSelect', 'buildingIds']),
    ...mapGetters('inspectionTour', [
      'streamMap',
      'orderingRuleActive',
      'classStatusStore',
      'currentPageStore',
      'searchKeywordsStore'
    ])
  },
  watch: {
    schoolSelect: {
      handler: function (newVal) {
        if (!newVal || !this.buildingIds) return
        this.setCurrentPage(1)
        this.getClassroomCourseList()
      }
    },
    buildingIds: {
      handler: function (newVal) {
        if (!newVal || !this.schoolSelect) return
        this.setCurrentPage(1)
        this.getClassroomCourseList()
      }
    },
    socketMsgSmallRoom: {
      handler: function (newVal) {
        this.dealSocketMsgSmallRoom(newVal)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapMutations('inspectionTour', {
      setOrderingRuleActive: 'setOrderingRuleActive',
      setClassStatusStore: 'setClassStatusStore',
      setCurrentPageStore: 'setCurrentPageStore',
      setSearchKeywordsStore: 'setSearchKeywordsStore'
    }),
    handleOrderingRuleItem({ key, disabled }) {
      if (disabled) return
      this.setOrderingRuleActive(key)
      this.setCurrentPage(1)
      this.getClassroomCourseList()
    },
    handleClassroomCourseItem(item) {
      const params = {}
      const { status, liveId, classroomCode } = item
      switch (status) {
        case 0:
          Object.assign(params, {
            name: 'HistoricalReplay',
            query: {
              classroomCode
            }
          })
          break
        case 1:
          Object.assign(params, {
            name: 'InspectionTourDetail',
            query: {
              liveId,
              classroomCode
            }
          })
          break
      }
      this.$router.push(params)
    },
    getClassroomCourseList() {
      try {
        this.timerIdTimeoutGetClassroomCourseList && clearTimeout(this.timerIdTimeoutGetClassroomCourseList)
        this.timerIdTimeoutGetClassroomCourseList = setTimeout(async () => {
          const params = {
            schoolCode: this.schoolSelect,
            buildingIds: this.buildingIds,
            sortBy: sortByObj[this.orderingRuleActive],
            keywords: this.searchKeywords,
            status: classStatusObj[this.classStatus],
            pageNum: this.currentPage,
            pageSize: this.pageSize
          }
          this.classroomCourseListLoading = true
          const result = await this.$http.classroomInspectionSearchByPage(params)
          this.classroomCourseListLoading = false
          if (result.code !== 200) return
          const info = result.rt || {}
          this.totalCount = info.totalCount
          this.classroomExt = info.ext || {}
          this.classroomCourseList = info.list || []
          if (!this.totalCount) {
            this.classroomCourseListEmpty = true
          } else {
            this.classroomCourseListEmpty = false
          }
          this.classroomCourseListStatusStarting = this.classroomCourseList.filter((item) => item.status === 1)
          this.operationDOM()
          await this.ZRTCInitAll(Array.from(new Set(this.classroomCourseListStatusStarting.map((item) => item.liveId))))
          this.getSocketMessage()
          // this.initStream(this.classroomCourseListStatusStarting)
        }, 500)
      } catch (err) {
        console.log(err)
      }
    },
    handleClassStatusChange() {
      this.setClassStatusStore(this.classStatus)
      this.setCurrentPage(1)
      this.getClassroomCourseList()
    },
    handleSearchKeywords() {
      this.setSearchKeywordsStore(this.searchKeywords)
      this.setCurrentPage(1)
      this.getClassroomCourseList()
    },
    paginationChange(page) {
      this.setCurrentPage(page)
      this.getClassroomCourseList()
    },
    async ZRTCInit(liveId) {
      try {
        const client = ZRTC2.init(liveId)
        client.setClientRole('audience')
        client.setBaseUrl({
          // hilive: 'https://tju-hilive.zhihuishu.com',
          hilive: 'https://zhs-hilive.zhihuishu.com',
          // 'zhihuishu-livecourse-desktop': 'https://tju-zhihuishu-livecourse-desktop.zhihuishu.com'
          'zhihuishu-livecourse-desktop': 'https://zhs-zhihuishu-livecourse-desktop.zhihuishu.com'
        })
        await client.joinAudienceRoom()
        console.log(liveId + ' joinRoom success')
        return client
      } catch (err) {
        console.log(err, 'joinRoom_err')
      }
    },
    async ZRTCInitAll(list) {
      await Promise.all(
        list.map((item) => {
          return (async () => {
            if (!this.ZRTCClientMap.get(item)) {
              const res = await this.ZRTCInit(item)
              if (res) {
                this.ZRTCClientMap.set(item, res)
              }
            }
            this.initStream(this.classroomCourseListStatusStarting)
          })()
        })
      )
    },
    getSocketMessage() {
      for (let item of this.ZRTCClientMap.keys()) {
        const client = this.ZRTCClientMap.get(item)
        if (!this.haveoOnSignalMessageMap.get(item) && client) {
          client.onSignalMessage((data) => {
            this.socketMsgSmallRoom = data.response
          })
          this.haveoOnSignalMessageMap.set(item, true)
        }
      }
    },
    async dealSocketMsgSmallRoom(message) {
      const { type, content = {} } = message
      if (
        Object.values(SOCKET_MSG_TYPE)
          .filter((item) => item !== SOCKET_MSG_TYPE.VOLUME_INDICATOR)
          .includes(type)
      ) {
        console.log(message, 'message_dealSocketMsgSmallRoom')
      }
      switch (type) {
        case SOCKET_MSG_TYPE.LIVE_STATUS_UPDATE:
          console.log(content, 'content_LIVE_STATUS_UPDATE')
          this.getClassroomCourseList()
          break
        case SOCKET_MSG_TYPE.VOLUME_INDICATOR:
          console.log(content, 'content_VOLUME_INDICATOR')
          console.log(this.classroomCourseList, 'classroomCourseList_VOLUME_INDICATOR')
          ;(content || []).forEach((item) => {
            this.mapStreamIdVolume.set(item.streamId, item.volume)
          })
          this.classroomCourseList = this.classroomCourseList.map((item) => {
            const volume = this.mapStreamIdVolume.get(item.audioStreamId)
            if (volume) {
              item.speaking = true
              item.barHeightForAudio = (Math.random() + 2) * volume + '%'
            } else {
              item.speaking = false
              item.barHeightForAudio = '0%'
            }
            return item
          })
          break
      }
    },
    initStream(list) {
      for (let i = 0, len = list.length; i < len; i++) {
        ;(async (i) => {
          try {
            const clientForZRTC = this.ZRTCClientMap.get(list[i].liveId)
            if (clientForZRTC && list[i].videoStreamId) {
              console.log(list[i].videoStreamId, 'list[i].videoStreamId--订阅此流id')
              const res = await clientForZRTC.subscribe(list[i].videoStreamId, 'video', VIDEO_LEVEL.MID)
              this.streamMap.set(res.streamId, res)
              console.log(this.streamMap, 'this.streamMap')
              this.operationDOM()
            }
          } catch (err) {
            console.log(err, 'errSubscribeStream')
          }
        })(i)
      }
    },
    operationDOM() {
      this.$nextTick(() => {
        this.classroomCourseList = this.classroomCourseList.map((item) => {
          if (item.rtcType === 'artc') {
            const domId = `J_prismPlayer_video_teacherUserId${item.teacherUserId}`
            const playerForAliplayer = this.mapAliplayerVideo.get(domId)
            if (playerForAliplayer && item.cdnRtsPullUrl) {
              playerForAliplayer.loadByUrl(url)
            } else {
              this.initAliplayerVideo(domId, item.cdnRtsPullUrl, true)
            }
          } else {
            const domVideo = document.querySelector(`#video_teacherUserId${item.teacherUserId}`)
            const videoStream = this.streamMap.get(item.videoStreamId)
            if (domVideo) {
              if (domVideo.srcObject !== videoStream) {
                domVideo.srcObject = videoStream
              }
            }
            if (videoStream) {
              item['videoShow'] = true
            } else {
              item['videoShow'] = false
            }
          }
          return item
        })
      })
    },
    initAliplayerVideo(id, url, setMap) {
      const props = {
        id,
        width: '100%',
        height: '100%',
        autoplay: true,
        preload: true,
        controlBarVisibility: 'always',
        useH5Prism: true,
        playsinline: true,
        isLive: false,
        language: 'zh-cn',
        source: '',
        cover: '',
        components: [],
        skinLayout: []
      }
      this.$nextTick(() => {
        const playerForAliplayer = new Aliplayer(props)
        url && playerForAliplayer.loadByUrl(url)
        playerForAliplayer.setVolume(0)
        setMap && this.mapAliplayerVideo.set(id, playerForAliplayer)
      })
    },
    leaveRoomZRTCClientMap() {
      for (let item of this.ZRTCClientMap.values()) {
        item.leaveRoom()
      }
    },
    disposeMapAliplayerVideo() {
      for (let item of this.mapAliplayerVideo.values()) {
        item.dispose()
      }
    },
    setCurrentPage(page) {
      this.currentPage = page
      this.setCurrentPageStore(page)
    }
  },
  mounted() {
    this.classStatus = this.classStatusStore
    this.currentPage = this.currentPageStore
    this.searchKeywords = this.searchKeywordsStore
    this.getClassroomCourseList()
    this.timerIdIntervalGetClassroomCourseList = setInterval(
      () => {
        this.getClassroomCourseList()
      },
      5 * 60 * 1000
    )
  },
  beforeDestroy() {
    this.leaveRoomZRTCClientMap()
    this.timerIdIntervalGetClassroomCourseList && clearInterval(this.timerIdIntervalGetClassroomCourseList)
    this.timerIdTimeoutGetClassroomCourseList && clearTimeout(this.timerIdTimeoutGetClassroomCourseList)
  }
}
</script>

<style lang="scss" scoped>
.page_container {
  width: 100%;
  height: 100%;
  padding: 16px;
  .ordering_rule_list {
    width: 100%;
    height: 36px;
    display: flex;
    border-bottom: 1px solid #f5f6f8;
    .ordering_rule_item {
      width: 100px;
      height: 36px;
      background: #f7f8fa;
      border: 1px solid #d5d7df;
      font-size: 14px;
      color: #323233;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      user-select: none;
      &.active {
        background: #ffffff;
        border-bottom: none;
        color: #5f60d3;
        border-top: 2px solid #5f60d3;
      }
      &:hover {
        font-weight: bold;
      }
      &.disabled {
        background: #eceef3;
        cursor: not-allowed;
        color: #afb1b8;
        &:hover {
          font-weight: normal;
        }
      }
    }
  }

  .search_container {
    width: 100%;
    height: 32px;
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    ::v-deep.ant-input-affix-wrapper {
      width: 240px;
      .ant-input-suffix {
        img {
          width: 20px;
          height: 20px;
          display: block;
        }
      }
    }
    ::v-deep.ant-radio-wrapper.ant-radio-wrapper-checked {
      color: #5f60d3;
      .ant-radio-checked {
        .ant-radio-inner {
          border-color: #5f60d3;
        }
        .ant-radio-inner::after {
          background-color: #5f60d3;
        }
      }
    }
    ::v-deep.ant-pagination-prev .ant-pagination-item-link,
    ::v-deep.ant-pagination-next .ant-pagination-item-link {
      border: none;
      color: #5f60d3 !important;
    }
    ::v-deep.ant-pagination-item {
      border: none;
      &:hover {
        a {
          color: #5f60d3;
        }
      }
    }
    ::v-deep.ant-pagination-item-link-icon {
      color: #5f60d3 !important;
    }
    ::v-deep.ant-pagination-item.ant-pagination-item-active {
      border: 1px solid #5f60d3;
      a {
        color: #5f60d3;
      }
    }
  }

  .body_container {
    width: 100%;
    height: auto;
    margin-top: 20px;
    position: relative;
    .body_container_loading {
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.5);
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .body_container_content {
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
    }
    .body_container_empty {
      width: 100%;
      height: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .classroom_course_item {
      // width: calc((100vw - 152px - 40px - 192px - 32px - 24px) / 3);
      width: calc((100% - 24px) / 3);
      height: calc(((100vw - 152px - 40px - 192px - 32px - 24px) / 3) / 16 * 9 + 50px);
      margin-bottom: 12px;
      box-shadow: 0px 2px 6px 0px rgba(1, 22, 43, 0.08);
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
      &:hover {
        box-shadow: 0px 0px 6px 0px rgba(1, 22, 43, 0.28);
      }
      &:nth-of-type(3n + 1),
      &:nth-of-type(3n + 2) {
        margin-right: 12px;
      }
      .classroom_course_item_video {
        width: 100%;
        height: calc(((100vw - 152px - 40px - 192px - 32px - 24px) / 3) / 16 * 9);
        background-color: #222;
        position: relative;
        .classroom_course_item_video_bar {
          width: 100%;
          height: 28px;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.1) 100%);
          position: absolute;
          bottom: 0px;
          left: 0px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          padding: 0 8px;
        }
        .J_prismPlayer_class {
          width: 100%;
          height: 100%;
        }
        video {
          width: 100%;
          height: 100%;
          background-color: #000;
          display: block;
          object-fit: fill;
        }
        .video_mask_container {
          width: 100%;
          height: 100%;
          background-color: #1e2228;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .video_mask_container_title {
            font-size: 14px;
            color: #9ca5b1;
            margin-top: 10px;
          }
          .sk-fading-circle {
            width: 40px;
            height: 40px;
            position: relative;
          }
          .sk-fading-circle .sk-circle {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
          }
          .sk-fading-circle .sk-circle:before {
            content: '';
            display: block;
            margin: 0 auto;
            width: 15%;
            height: 15%;
            background-color: #ed6c04;
            border-radius: 100%;
            -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
            animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
          }
          .sk-fading-circle .sk-circle2 {
            -webkit-transform: rotate(30deg);
            -ms-transform: rotate(30deg);
            transform: rotate(30deg);
          }
          .sk-fading-circle .sk-circle3 {
            -webkit-transform: rotate(60deg);
            -ms-transform: rotate(60deg);
            transform: rotate(60deg);
          }
          .sk-fading-circle .sk-circle4 {
            -webkit-transform: rotate(90deg);
            -ms-transform: rotate(90deg);
            transform: rotate(90deg);
          }
          .sk-fading-circle .sk-circle5 {
            -webkit-transform: rotate(120deg);
            -ms-transform: rotate(120deg);
            transform: rotate(120deg);
          }
          .sk-fading-circle .sk-circle6 {
            -webkit-transform: rotate(150deg);
            -ms-transform: rotate(150deg);
            transform: rotate(150deg);
          }
          .sk-fading-circle .sk-circle7 {
            -webkit-transform: rotate(180deg);
            -ms-transform: rotate(180deg);
            transform: rotate(180deg);
          }
          .sk-fading-circle .sk-circle8 {
            -webkit-transform: rotate(210deg);
            -ms-transform: rotate(210deg);
            transform: rotate(210deg);
          }
          .sk-fading-circle .sk-circle9 {
            -webkit-transform: rotate(240deg);
            -ms-transform: rotate(240deg);
            transform: rotate(240deg);
          }
          .sk-fading-circle .sk-circle10 {
            -webkit-transform: rotate(270deg);
            -ms-transform: rotate(270deg);
            transform: rotate(270deg);
          }
          .sk-fading-circle .sk-circle11 {
            -webkit-transform: rotate(300deg);
            -ms-transform: rotate(300deg);
            transform: rotate(300deg);
          }
          .sk-fading-circle .sk-circle12 {
            -webkit-transform: rotate(330deg);
            -ms-transform: rotate(330deg);
            transform: rotate(330deg);
          }
          .sk-fading-circle .sk-circle2:before {
            -webkit-animation-delay: -1.1s;
            animation-delay: -1.1s;
          }
          .sk-fading-circle .sk-circle3:before {
            -webkit-animation-delay: -1s;
            animation-delay: -1s;
          }
          .sk-fading-circle .sk-circle4:before {
            -webkit-animation-delay: -0.9s;
            animation-delay: -0.9s;
          }
          .sk-fading-circle .sk-circle5:before {
            -webkit-animation-delay: -0.8s;
            animation-delay: -0.8s;
          }
          .sk-fading-circle .sk-circle6:before {
            -webkit-animation-delay: -0.7s;
            animation-delay: -0.7s;
          }
          .sk-fading-circle .sk-circle7:before {
            -webkit-animation-delay: -0.6s;
            animation-delay: -0.6s;
          }
          .sk-fading-circle .sk-circle8:before {
            -webkit-animation-delay: -0.5s;
            animation-delay: -0.5s;
          }
          .sk-fading-circle .sk-circle9:before {
            -webkit-animation-delay: -0.4s;
            animation-delay: -0.4s;
          }
          .sk-fading-circle .sk-circle10:before {
            -webkit-animation-delay: -0.3s;
            animation-delay: -0.3s;
          }
          .sk-fading-circle .sk-circle11:before {
            -webkit-animation-delay: -0.2s;
            animation-delay: -0.2s;
          }
          .sk-fading-circle .sk-circle12:before {
            -webkit-animation-delay: -0.1s;
            animation-delay: -0.1s;
          }
          @-webkit-keyframes sk-circleFadeDelay {
            0%,
            39%,
            100% {
              opacity: 0;
            }
            40% {
              opacity: 1;
            }
          }
          @keyframes sk-circleFadeDelay {
            0%,
            39%,
            100% {
              opacity: 0;
            }
            40% {
              opacity: 1;
            }
          }
        }
        .video_mask_container_real_top {
          width: 100%;
          height: 100%;
          background-color: #132238;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .video_mask_container_real_top_title {
            display: flex;
            align-items: center;
            img {
              width: 16px;
              height: 16px;
              display: block;
              margin-right: 8px;
            }
            p {
              font-size: 14px;
              color: #ffffff;
            }
          }
        }
        .power_off_container {
          width: 100%;
          height: 100%;
          background-color: #132238;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .power_off_container_title {
            display: flex;
            align-items: center;
            img {
              width: 16px;
              height: 16px;
              display: block;
              margin-right: 8px;
            }
            p {
              font-size: 14px;
              color: #ffffff;
            }
          }
          .power_off_container_sub_title {
            font-size: 12px;
            color: #9ca5b1;
          }
        }
      }
      .classroom_course_item_info {
        width: 100%;
        height: 50px;
        background-color: #fff;
        padding: 6px 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .info_title {
          font-size: 14px;
          color: #1e2228;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .info_sub_title {
          font-size: 12px;
          color: #9ca5b1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
